/* CRUX AURA lazy editorial video v1 */
(() => {
  const sectionSelector = "[id*='__media_with_content_aTtEXb']";
  const readyClass = 'crux-aura-video-ready';
  const buttonClass = 'crux-aura-editorial-video-toggle';

  const buttonMarkup = `
    <span class="crux-aura-video-icon crux-aura-video-icon--play" aria-hidden="true">
      <svg viewBox="0 0 16 16" focusable="false">
        <path d="M4 2.7v10.6c0 .7.8 1.1 1.4.7l8-5.3a.84.84 0 0 0 0-1.4l-8-5.3A.84.84 0 0 0 4 2.7Z"/>
      </svg>
    </span>
    <span class="crux-aura-video-icon crux-aura-video-icon--pause" aria-hidden="true">
      <svg viewBox="0 0 16 16" focusable="false">
        <path d="M3.5 2.5h3v11h-3zm6 0h3v11h-3z"/>
      </svg>
    </span>
  `;

  function bindVideo(section, video) {
    if (video.dataset.cruxAuraEditorialControl === 'true') return;

    video.dataset.cruxAuraEditorialControl = 'true';
    video.controls = false;
    video.removeAttribute('controls');

    if (!video.id) video.id = 'crux-aura-editorial-video';

    const media = section.querySelector('deferred-media') || video.parentElement;
    let button = section.querySelector(`.${buttonClass}`);

    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = buttonClass;
      button.setAttribute('aria-controls', video.id);
      button.innerHTML = buttonMarkup;
      media.appendChild(button);
    }

    const updateButton = () => {
      const isPlaying = !video.paused && !video.ended;
      button.dataset.state = isPlaying ? 'playing' : 'paused';
      button.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
    };

    button.addEventListener('click', async () => {
      if (video.paused || video.ended) {
        try {
          await video.play();
        } catch (_error) {
          updateButton();
        }
      } else {
        video.pause();
      }
    });

    video.addEventListener('play', updateButton);
    video.addEventListener('pause', updateButton);
    video.addEventListener('ended', updateButton);
    section.classList.add(readyClass);
    updateButton();
  }

  function initializeSection(section) {
    if (section.dataset.cruxAuraEditorialInitialized === 'true') return;
    section.dataset.cruxAuraEditorialInitialized = 'true';

    const media = section.querySelector('deferred-media');
    if (!media) return;

    const connect = () => {
      const video = media.querySelector('video');
      if (!video) return false;
      bindVideo(section, video);
      return true;
    };

    if (connect()) return;

    const mutationObserver = new MutationObserver(() => {
      if (connect()) mutationObserver.disconnect();
    });
    mutationObserver.observe(media, { childList: true, subtree: true });

    const posterButton = media.querySelector('[ref="deferredMediaPlayButton"]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!posterButton || reducedMotion || !('IntersectionObserver' in window)) return;

    const loadObserver = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      loadObserver.disconnect();
      if (posterButton.isConnected) posterButton.click();
    }, { rootMargin: '360px 0px', threshold: 0.01 });

    loadObserver.observe(section);
  }

  function initialize(root = document) {
    root.querySelectorAll(sectionSelector).forEach(initializeSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
